import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var emptyStateComponentName = 'QuantumEmptyState';
export function getEmptyStateUtilityClass(slot) {
    return generateUtilityClass(emptyStateComponentName, slot);
}
export var emptyStateClasses = generateUtilityClasses(emptyStateComponentName, [
    'root',
    'card',
    'pageHeader',
    'subtitle',
    'content',
    'icon',
    'message',
    'actions',
    'link',
]);
